import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Mascot from '../components/Mascot';

export default function Type() {
  const [text, setText] = useState('');
  const [note, setNote] = useState('');
  const navigate = useNavigate();

  const go = () => {
    if (!text.trim()) return;
    sessionStorage.setItem(
      'mb_input',
      JSON.stringify({
        text,
        note: note.trim() || undefined,
        source: 'type',
      })
    );
    navigate('/solve');
  };

  return (
    <div className="max-w-xl mx-auto px-5 pt-10 safe-top space-y-6">
      <header className="flex items-center gap-3">
        <Mascot mood="thinking" size={56} />
        <div>
          <h1 className="font-display font-black text-2xl leading-none">Type a question</h1>
          <p className="text-ink/70 text-sm">What does the problem say?</p>
        </div>
      </header>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="e.g., Find the surface area of a box that is 4 by 3 by 2."
        rows={6}
        className="w-full card p-4 text-ink outline-none focus:ring-2 focus:ring-coral/50"
      />

      <div className="space-y-2">
        <label htmlFor="note" className="text-sm font-semibold text-ink/80">
          Add a note <span className="text-ink/50 font-normal">(optional)</span>
        </label>
        <textarea
          id="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={2}
          maxLength={300}
          placeholder="e.g., I think the answer is 12 but I'm stuck on part b"
          className="w-full card p-3 text-sm text-ink outline-none focus:ring-2 focus:ring-coral/50"
        />
      </div>

      <button onClick={go} className="btn-primary w-full" disabled={!text.trim()}>
        Let's solve it →
      </button>
    </div>
  );
}
